export const messagesConstants = {
    ADD_SUCCESS_MESSAGE: 'ADD_SUCCESS_MESSAGE',
    ADD_ERROR_MESSAGE: 'ADD_ERROR_MESSAGE',
    ADD_INFO_MESSAGE: 'ADD_INFO_MESSAGE',

    CLEAR_ALL_MESSAGES: 'CLEAR_ALL_MESSAGES'
}


// WEBPACK FOOTER //
// ./src/constants/messages.js